import moment from "moment";
import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Delete from "@material-ui/icons/Delete";
import { Tooltip, IconButton, Grid } from "@material-ui/core";

import {
  ACTIONS,
  WORK_SCHEDULE_OVERRIDE_FORM,
  EDIT_WORK_SCHEDULE_OVERRIDE_MODAL_ID,
  CREATE_WORK_SCHEDULE_OVERRIDE_MODAL_ID,
  DEPLOYMENT_DETAILS_MODAL_ID,
} from "features/planner/employee/employee.constants";

import {
  editWorkScheduleOverrideOnSubmit,
  createWorkScheduleOverrideOnSubmit,
  toggleCreateWorkScheduleOverrideModal,
  deleteWorkScheduleOverride,
} from "features/planner/employee/employee.actions";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import { getModifiedByValue } from "utils/app.util";
import SimpleFormModal from "app/components/SimpleFormModal";
import { getActionDataStateFromState } from "app/app.selectors";
import SortableList from "app/components/SortableList/SortableList";
import {
  SORT_DIRECTION,
  DEPLOYMENT_DETAILS_FORM,
} from "features/planner/planner.constants";
import SortableListRowIcon from "app/components/SortableList/SortableListRowIcon";
import { workScheduleOverrideReasonToString } from "features/planner/planner.mappers";
import EmployeeCalendar from "features/planner/employee/calendar/components/EmployeeCalendar";
import { getWorkScheduleOverridesFromState } from "features/planner/employee/employee.selectors";
import WorkScheduleOverrideForm from "features/planner/employee/calendar/components/WorkScheduleOverrideForm";
import DeploymentDetailsForm from "features/planner/employee/calendar/components/DeploymentDetailsForm";
import BasePage from "app/components/BasePage";

class EmployeeWorkScheduleContainer extends PureComponent {
  columns = [
    {
      xs: true,
      title: "Reason",
      getSortProperty: item =>
        workScheduleOverrideReasonToString(item.get("overrideReason")),
    },
    {
      xs: true,
      title: "Notes",
      getSortProperty: item => item.get("notes"),
    },
    {
      xs: true,
      title: "From",
      getSortProperty: item => formatDate(item.get("startDate"), Format.date),
    },
    {
      xs: true,
      title: "To",
      getSortProperty: item => formatDate(item.get("endDate"), Format.date),
    },
    {
      xs: true,
      component: Grid,
      title: "Modified",
      getSortProperty: item => formatDate(item.get("modified")),
      getValue: getModifiedByValue,
    },
  ];

  actions = [
    {
      getValue: item => (
        <Tooltip title="Delete">
          <IconButton
            onClick={() =>
              this.props.dispatchDeleteWorkScheduleOverride(
                this.props.employeeCardId,
                item,
              )
            }
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  initializeCreateWorkScheduleOverride = (startDate, endDate, callback) => {
    const {
      employeeCardId,
      dispatchToggleWorkScheduleOverrideModal,
    } = this.props;

    dispatchToggleWorkScheduleOverrideModal(
      employeeCardId,
      startDate,
      endDate,
      callback,
    );
  };

  addButtonOnClick = () =>
    this.initializeCreateWorkScheduleOverride(moment(), moment());

  getKey = workScheduleOverride => workScheduleOverride.get("id");

  renderIcon = () => <SortableListRowIcon transparent />;

  render() {
    const {
      Icon,
      breadcrumb,
      employeeCardId,
      dataState,
      workScheduleOverrides,
      dispatchEditWorkScheduleOverrideOnSubmit,
      dispatchCreateWorkScheduleOverrideOnSubmit,
    } = this.props;

    return (
      <>
        <BasePage
          Icon={Icon}
          title={breadcrumb}
          displayAddButton
          dataState={dataState}
          addButtonOnClick={this.addButtonOnClick}
        >
          <EmployeeCalendar
            employeeCardId={employeeCardId}
            workScheduleOverrides={workScheduleOverrides}
            initializeCreateWorkScheduleOverride={
              this.initializeCreateWorkScheduleOverride
            }
          />
          <Grid container>
            <SortableList
              Icon={null}
              getKey={this.getKey}
              defaultSortColumn={4}
              dataState={dataState}
              columns={this.columns}
              actions={this.actions}
              renderIcon={this.renderIcon}
              items={workScheduleOverrides}
              noResultsMessage="No events..."
              defaultSortDirection={SORT_DIRECTION.DESC}
              onRowClick={this.initializeEditWorkSchedule}
            />
          </Grid>
        </BasePage>
        <SimpleFormModal
          Icon={null}
          submitText="Add"
          title="Add event"
          component={WorkScheduleOverrideForm}
          modalId={CREATE_WORK_SCHEDULE_OVERRIDE_MODAL_ID}
          onSubmit={dispatchCreateWorkScheduleOverrideOnSubmit}
          form={{
            form: WORK_SCHEDULE_OVERRIDE_FORM.ID,
          }}
        />
        <SimpleFormModal
          Icon={null}
          submitText="Save"
          title="Edit event"
          component={WorkScheduleOverrideForm}
          modalId={EDIT_WORK_SCHEDULE_OVERRIDE_MODAL_ID}
          onSubmit={dispatchEditWorkScheduleOverrideOnSubmit(employeeCardId)}
          form={{
            form: WORK_SCHEDULE_OVERRIDE_FORM.ID,
          }}
        />
        <SimpleFormModal
          Icon={null}
          title="Deployment"
          displaySubmitBtn={false}
          displayCancelBtn={false}
          component={DeploymentDetailsForm}
          modalId={DEPLOYMENT_DETAILS_MODAL_ID}
          onSubmit={dispatchEditWorkScheduleOverrideOnSubmit(employeeCardId)}
          form={{
            form: DEPLOYMENT_DETAILS_FORM.ID,
          }}
        />
      </>
    );
  }
}

export default compose(
  connect(
    state => ({
      workScheduleOverrides: getWorkScheduleOverridesFromState(state),
      dataState: getActionDataStateFromState(
        state,
        ACTIONS.EMPLOYEE_CALENDAR_ON_LOAD,
      ),
    }),
    {
      dispatchEditWorkScheduleOverrideOnSubmit: editWorkScheduleOverrideOnSubmit,
      dispatchDeleteWorkScheduleOverride: deleteWorkScheduleOverride,
      dispatchToggleWorkScheduleOverrideModal: toggleCreateWorkScheduleOverrideModal,
      dispatchCreateWorkScheduleOverrideOnSubmit: createWorkScheduleOverrideOnSubmit,
    },
  ),
)(EmployeeWorkScheduleContainer);
